// extracted by mini-css-extract-plugin
export default {"bgPagination":"planListing_bgPagination__PKA1w","paginationRow":"planListing_paginationRow__I1iaQ"};